import { mapGetters, mapActions } from 'vuex';
import store from './store';

export default {
  props: {
    // 服务类型:null所有/1自助/2三方
    ServiceType: {
      type: Number,
      default: null,
    },
    // 服务状态:null所有/1开启/0关闭
    ServiceState: {
      type: Number,
      default: null,
    },
    isAll: {
      type: Number,
      default: null,
    },
  },
  created() {
    store.install(this.$store);
    if (!this.serviceTypeLists[this.ServiceType].length) {
      this.fetchServiceTypeList({
        serviceType: this.ServiceType,
        serviceState: this.ServiceState,
        isAll: this.isAll,
      });
    }
  },
  computed: {
    ...mapGetters('serviceTypeOption', ['serviceTypeLists']),
  },
  methods: {
    ...mapActions('serviceTypeOption', ['fetchServiceTypeList']),
    getServiceTypeName(id) {
      let item = this.serviceTypeLists[this.ServiceType].find(
        ServiceType => ServiceType.id === id
      );
      return item ? item.serviceName : '';
    },
  },
};
